import styled, { css } from 'styled-components';

export const LoaderWrapper = styled.div`
  ${({ noMinHeight }) => css`
    justify-self: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: ${noMinHeight ? 0 : '337px'};
    gap: 16px;
    align-items:center;
  `}
`;

export const Message = styled.p`
  ${({ theme }) => css`
    margin: 16px 0px 0px 0px !important;
    color: ${theme.palette.grey.dark};
    font-family: ${theme.font.family.secondary};
    font-size: ${theme.font.sizes.md};
    line-height: ${theme.font.lineHeights.xl};
    font-weight: ${theme.font.weights.medium};
  `}
`;
